import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { translate } from '~l10n/client';

import { JoinWorkspaceEventAdapter } from '~analytics/adapters/JoinWorkspaceEventAdapter';
import { toast } from '~shared/components/Toast';
import { ErrorDialog } from '~teacher/components/ErrorDialog';
import { JoinWorkspaceModal } from '~teacher/components/JoinWorkspaceModal/JoinWorkspaceModal';

import { isAxiosError } from '../../api/isAxiosError';
import {
  getWorkspaceByCode,
  joinWorkspace,
} from '../../api/workspaces/join/joinWorkspace';

interface JoinWorkspacePageParams {
  workspaceCode: string;
  router: any;
}

export function JoinWorkspacePage({
  workspaceCode,
  router,
}: JoinWorkspacePageParams) {
  const [workspaceId, setWorkspaceId] = React.useState<string>(null);
  const [workspaceName, setWorkspaceName] = React.useState<string>(null);
  const [apiError, setApiError] = React.useState<string>(null);

  React.useEffect(() => {
    getWorkspaceByCode({ workspaceCode: workspaceCode })
      .then((data) => {
        setWorkspaceId(data.workspaceId);
        setWorkspaceName(data.name);
      })
      .catch((err) => {
        console.error(err);
        const error = err?.response?.data?.message ?? '';
        setApiError(error);
      });
  }, [workspaceCode]);

  const onClose = () => {
    router.routeToLaunch();
  };

  const handleConfirmJoin = () => {
    joinWorkspace({
      workspaceCode: workspaceCode,
      workspaceId: workspaceId,
    })
      .then(() => {
        new JoinWorkspaceEventAdapter({
          workspace_id: workspaceId,
          join_method: 'link',
        }).sendAnalytics();
        router.routeToWorkspace(workspaceId);
      })
      .catch((error) => {
        if (__DEV__) {
          console.error(error);
        }
        if (isAxiosError(error)) {
          if (error.response.status === 422) {
            router.routeToLaunch();
            toast.critical(
              translate(
                'Failed to join the library due to membership capacity being reached.'
              )
            );
          } else {
            setApiError(error.response.data.message ?? '');
          }
        } else {
          setApiError(error);
        }
      });
  };

  return (
    <div>
      {apiError ? (
        <ErrorDialog open={true} onClose={onClose} serverMessage={apiError} />
      ) : (
        <JoinWorkspaceModal
          open={!!workspaceName}
          workspaceName={workspaceName}
          onClose={onClose}
          onConfirm={handleConfirmJoin}
        />
      )}
    </div>
  );
}

interface DoJoinWorkspacePageParams {
  router: any;
  workspaceCode: string;
}
export function doJoinWorkspacePage({
  workspaceCode,
  router,
}: DoJoinWorkspacePageParams) {
  const mainContent = document.getElementById('main-content');
  ReactDOM.render(
    <JoinWorkspacePage workspaceCode={workspaceCode} router={router} />,
    mainContent
  );
}
